import { AnnouncementEventAddedOrUpdatedInDatabase } from "../../constants";
import { executeEventually } from "../../lib/utils/executeEventually";
import { UUID } from "../../State/EvidenceDB/DatabaseTypes";
import { DbEventsTableReader } from "../../State/EvidenceDB/DbEventsTableReader";
import { EventUpdatedInDatabase, NewEventAddedToDatabase } from "../../State/StateEvents";
import { InstrumentationReportingState } from "./InstrumentationReportingState";


export class InstrumentationReportingDatabaseState extends InstrumentationReportingState {

	eventsTableReader: DbEventsTableReader;


	update = executeEventually(async () => {
		await this.eventsTableReader.forEventsWithCategory('Instrumentation', this.highestEventIndexProcessed + 1)((e) => {
			this.highestEventIndexProcessed = Math.max(this.highestEventIndexProcessed, e.eventIndex);
			this.processInstrumentationEvent(e);
			return;
		});
	});

	constructor(public readonly recordingUuid: UUID) {
		super();
		this.eventsTableReader = DbEventsTableReader.forRecordingUuid(this.recordingUuid);

		const onNewOrUpdatedEvent = async ({recordingUuid, eventIndex, category}: AnnouncementEventAddedOrUpdatedInDatabase) => {
			if (category !== "Instrumentation") return;
			if (recordingUuid !== this.recordingUuid) return;
			const dbEvent = await this.eventsTableReader.getEvent(eventIndex);
			if (dbEvent == null || dbEvent.category !== "Instrumentation") return;
			this.processInstrumentationEvent(dbEvent);
		}

		NewEventAddedToDatabase.addListener(onNewOrUpdatedEvent);
		EventUpdatedInDatabase.addListener(onNewOrUpdatedEvent);
		this.update();
	}
}
